import {adminApi, apiV2, coachingApi} from './api';
import {List, Map} from 'immutable';
import omit from 'lodash/omit';
import snakeize from 'snakeize';
import User from 'records/User';

// TODO clean up fetch methods.. they both seem to be fetching lists of users based on
// varying criteria, however, both endpoints accept different parameters
export default {
  /*
    Fetch users based on the following params (and maybe more):
      searchTerm - auto complete of the users name (and maybe other info?)
      teamId - users in a particular team
  */
  fetch(normalizedParams, cancelConfig) {
    // let's just rename this param 'searchTerm', because 'q' is not too readable
    const serverParams = {
      ...omit(normalizedParams, ['searchTerm']),
      q: normalizedParams.searchTerm,
    };
    return apiV2
      .getJson('users/autocomplete', {
        ...cancelConfig,
        params: snakeize(serverParams),
      })
      .then(({users}) => List(users.map(user => new User(user))));
  },
  /*
    Fetch users based on the following params (and maybe more):
      ids - get a list of users with the given IDs
      roles - get a list of users matching the given role (manager, user, etc.)
  */
  fetchAll(params): Promise<List<User>> {
    // TODO move immutable unwrapping into api code
    const plainParams = Map(params).toJS();
    if (params && params.ids && params.ids.size === 0) {
      return Promise.resolve(List([]));
    }
    return coachingApi.postJson('/users/fetch', plainParams).then(
      users => List(users.map(user => new User(user))),
      error => {
        // eslint-disable-next-line
        throw [params, error];
      }
    );
  },

  fetchUsersInTeams(teamIds) {
    const list = List(teamIds);
    if (list.size === 0) {
      return Promise.resolve(List());
    }
    const params = {params: {team_id: list.toJS()}};
    return coachingApi.getJson('/users/in_teams', params).then(
      users => List(users.map(user => new User(user))),
      error => {
        // eslint-disable-next-line
        throw [teamIds, error];
      }
    );
  },

  fetchManagersAndCoaches() {
    return coachingApi
      .getJson('/users/managers_and_coaches')
      .then(users => List(users.map(user => new User(user))));
  },

  fetchManager(params) {
    return adminApi.getJson('/managers', {params: snakeize(params)}).then(
      manager => [new User(manager), params],
      error => {
        // eslint-disable-next-line
        throw [params, error];
      }
    );
  },

  update(user: User) {
    return adminApi.put(`/users/simple/${user.id}`, user).then(u => new User(u.data));
  },

  fetchSimple(userId: string) {
    return adminApi.get(`/users/simple/${userId}`).then(u => new User(u.data));
  },

  fetchGum(globalUserId?: string) {
    return adminApi.getJson(`/users/gum/fetch`, {params: {globalUserId}}).then(u => new User(u));
  },
};
